import createVueComponent from '../createVueComponent';
var Trash2 = createVueComponent('Trash2Icon', [['polyline', {
  points: '3 6 5 6 21 6',
  key: 'c9uf7f'
}], ['path', {
  d: 'M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2',
  key: '1c5b1m'
}], ['line', {
  x1: '10',
  y1: '11',
  x2: '10',
  y2: '17',
  key: 'm9v7hp'
}], ['line', {
  x1: '14',
  y1: '11',
  x2: '14',
  y2: '17',
  key: '23cpt9'
}]]);
export default Trash2;